import React from 'react';
import Icon from '../../../components/AppIcon';

const RoleSelector = ({ selectedRole, onRoleChange, disabled = false }) => {
  const roles = [
    {
      id: 'va',
      title: 'Virtual Assistant',
      description: 'I want to find work and offer my services',
      icon: 'User'
    },
    {
      id: 'employer',
      title: 'Employer',
      description: 'I want to hire virtual assistants',
      icon: 'Building'
    },
    {
      id: 'admin',
      title: 'Administrator',
      description: 'Platform administrator with full access',
      icon: 'Shield',
      hidden: selectedRole !== 'admin' // Only show if selected (from invitation)
    },
    {
      id: 'moderator',
      title: 'Moderator',
      description: 'Content moderator and community manager',
      icon: 'ShieldCheck',
      hidden: selectedRole !== 'moderator' // Only show if selected (from invitation)
    }
  ];

  // Filter out hidden roles
  const visibleRoles = roles.filter(role => !role.hidden);

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-text-primary mb-3">
        I am a...
      </label>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {visibleRoles.map(role => (
          <button
            key={role.id}
            type="button"
            onClick={() => !disabled && onRoleChange(role.id)}
            disabled={disabled}
            className={`
              p-4 border-2 rounded-lg text-left transition-all duration-200
              hover:shadow-md focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2
              disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-none
              ${selectedRole === role.id
                ? 'border-primary bg-primary-50 text-primary-700' :'border-border bg-white text-text-secondary hover:border-primary-300'
              }
            `}
          >
            <div className="flex items-start space-x-3">
              <div className={`
                w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0
                ${selectedRole === role.id
                  ? 'bg-primary text-white' :'bg-gray-100 text-gray-500'
                }
              `}>
                <Icon name={role.icon} size={16} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className={`
                  font-medium text-sm
                  ${selectedRole === role.id ? 'text-primary-700' : 'text-text-primary'}
                `}>
                  {role.title}
                </h3>
                <p className={`
                  text-xs mt-1
                  ${selectedRole === role.id ? 'text-primary-600' : 'text-text-muted'}
                `}>
                  {role.description}
                </p>
              </div>
              {selectedRole === role.id && (
                <div className="flex-shrink-0">
                  <Icon name="CheckCircle" size={16} className="text-primary" />
                </div>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RoleSelector;
